@import (reference) '../../../constants/spacing.module.less';

@12px: 0.75rem;
@14px: 0.875rem;
@16px: 1rem;
@20px: 1.25rem;
@24px: 1.5rem;
@28px: 1.75rem;
@32px: 2rem;

.text-style(@font-size, @line-height, @font-weight: 400) {
  margin: @space-0;
  padding: @space-0;
  font-size: @font-size;
  line-height: @line-height;
  font-weight: @font-weight;
}

// These values are from design
// https://zeroheight.com/2d379a49f/p/4402fd-typography-

.h1 {
  .text-style(@28px, @32px);
}

.h2 {
  .text-style(@24px, @32px);
}

.h3 {
  .text-style(@20px, @24px);
}

.h4 {
  .text-style(@16px, @24px, 500);
}

.label {
  .text-style(@14px, @24px, 500);
}

.description {
  .text-style(@16px, @24px);
}

.paragraph {
  .text-style(@14px, @24px);
}

.caption {
  .text-style(@12px, @16px);
}

.truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bold {
  font-weight: 500;
}
